<div class="mainLayout">
  <div class="row layout">
    <span class="col-lg-12 col-md-12 closeDiv">
      <img src="../../../../assets/images/close-sm.svg" (click)="close()" class="cursor-pointer close" alt="" />
    </span>
    <div class="col-md-5 col-sm-12 leftHeader">
      <div>
        <h6>Transaction History Report</h6>
      </div>
      <div class="record">
        <span>{{ pageDatas.totalItems }} Records found</span>
      </div>
    </div>

    <div class="col-md-7 col-sm-12 rightHeader">
      <div class="rightDiv">
        <div class="search">
          <form [formGroup]="searchForm" class="rightDiv">
            <div class="searchText">
              <img src="../../../../assets/images/search-icon.png" class="searchImg" />
              <input class="form-control" type="text" formControlName="searchText1" name="search" autocomplete="off"
                placeholder="Search" (keyup)="onSearch($event)" style="font-family: Arial, FontAwesome" />
              </div>
            </form>
          </div>
          <div class="date-picker">
            <mat-form-field>
              <mat-date-range-input [rangePicker]="picker">
                <input matStartDate placeholder="Start date" [(ngModel)]="startDates"
                  (dateChange)="startDateChange($event)" />
                  <input matEndDate placeholder="End date" [(ngModel)]="endDates" (dateChange)="endDateChange($event)" />
                </mat-date-range-input>
                <mat-hint>MM/DD/YYYY – MM/DD/YYYY</mat-hint>
                <mat-datepicker-toggle matIconSuffix [for]="picker">
                </mat-datepicker-toggle>
                <mat-date-range-picker #picker></mat-date-range-picker>
              </mat-form-field>
            </div>

            <div class="download">
              @if (selectedTab == 'redFlag') {
                <button class="download-action" (click)="downRedFlagTran()">
                  <span>Download Report</span>
                </button>
              }
              @if (selectedTab == 'associates' || selectedTab == 'onboarding') {
                <button class="download-action"
                  (click)="downAsscTran()">
                  <span>Download Report</span>
                </button>
              }
            </div>
          </div>
        </div>
      </div>

      @if (!contentLoaded) {
        <ngx-skeleton-loader count="5" [theme]="{ height: '50px' }">
        </ngx-skeleton-loader>
      }

      @if (contentLoaded) {
        <div class="card asscCard">
          <p-table #dt [value]="history | paginate : config" [rows]="3" [paginator]="false"
            [globalFilterFields]="['firstName', 'contact', 'externalId']" [tableStyle]="{ 'min-width': 'auto' }"
      [rowHover]="true" dataKey="id" currentPageReportTemplate="Showing {first} to {last} of {{
        history.length
      }} entries" [showCurrentPageReport]="true" (onSort)="sortColumn($event)"
            [sortMode]="selectedTab == 'redFlag' ? 'single' : 'multiple'">
            <ng-template pTemplate="caption"> </ng-template>
            <ng-template pTemplate="header">
              <tr>
                <th pSortableColumn="firstName">
                  NAME/PHONE NUMBER
                  @if (selectedTab !== 'redFlag') {
                    <p-sortIcon field="firstName"></p-sortIcon>
                  }
                </th>
                <th pSortableColumn="externalId">
                  FLEX ID/EMP ID
                  @if (selectedTab !== 'redFlag') {
                    <p-sortIcon field="externalId"></p-sortIcon>
                  }
                </th>
                <th pSortableColumn="city">
                  CITY & SITE CODE
                  @if (selectedTab !== 'redFlag') {
                    <p-sortIcon field="city"></p-sortIcon>
                  }
                </th>
                @if (selectedTab !== 'redFlag') {
                  <th pSortableColumn="onboardingDate">
                    ONBOARDING
                    @if (selectedTab !== 'redFlag') {
                      <p-sortIcon field="onboardingDate"></p-sortIcon>
                    }
                  </th>
                }
                <th pSortableColumn="doj">
                  DOJ & DOL
                  @if (selectedTab !== 'redFlag') {
                    <p-sortIcon field="doj"></p-sortIcon>
                  }
                </th>
                <th pSortableColumn="lastUpdatedAt">
                  UPDATED & CREATED DATE
                  @if (selectedTab !== 'redFlag') {
                    <p-sortIcon field="lastUpdatedAt"></p-sortIcon>
                  }
                </th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-data let-rowIndex="rowIndex">
              <tr>
                <!-- <td>
                <p-tableCheckbox [value]="product"></p-tableCheckbox>
              </td> -->
              <td class="mat-cell d-flex">
            <div [ngClass]="
                data.flag == 'GREEN'
                  ? 'greenFlagClass'
                  : data.flag == 'ORANGE'
                  ? 'orangeFlagClass'
                  : data.flag == 'RED'
                  ? 'redFlagClass'
                  : ''
              "></div>
                <div class="user-des">
                  <p class="p1">{{ data.firstName }} {{ data.lastName }}</p>
                  <p class="p2">{{ data.contact }}</p>
                </div>
              </td>
              <td class="mat-cell">
                <p class="p1">{{ data.externalId }}</p>
                <p class="p2">{{ data.employeeId }}</p>
              </td>
              <td class="mat-cell">
                <p class="p1">{{ data.city }}</p>
                <p class="p2">{{ data.site }}</p>
              </td>
              @if (selectedTab !== 'redFlag') {
                <td class="mat-cell">
                  <p class="p1">
                    {{ data.onboardingDate ? data.onboardingDate : "NA" }}
                  </p>
                </td>
              }
              <td class="mat-cell">
                <p class="p1">{{ data.doj }}</p>
                <p class="p2">{{ data.dol }}</p>
              </td>
              <td class="mat-cell">
                <p class="p1">{{ data.lastUpdatedAt }}</p>
                <p class="p2">{{ data.createdAt }}</p>
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="6" style="text-align: center; border: none">
                <div style="margin-top: 20px">No Assocaites available</div>
              </td>
            </tr>
          </ng-template>
        </p-table>
        @if (config.totalItems > 4) {
          <div class="pagination-section my-pagination pageclass">
            <pagination-controls (pageChange)="setCurrent($event)" [nextLabel]="pageControls.nextLabels"
              [previousLabel]="pageControls.previousLabels" [responsive]="pageControls.responsives"
              [autoHide]="pageControls.autoHides" [id]="config.id">
            </pagination-controls>
          </div>
        }
      </div>
    }
  </div>